module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAAXNSR0IArs4c6QAAAE9JREFUOE/tkysOgEAQxVrBPRFYzgMJVyV5CDZ8BGQJdke3pnljkgkYgFkdebgblySFW9XuRTq5i4RqhYRN2jO1EGUuv0N8GuwC9BWvcXAbcNeG8cgDn2wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/暂停.png
// module id = Hji0
// module chunks = 3